import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/grid_list.svg
 */
const IconGridList: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.997 1H1.098a.114.114 0 00-.08.03C1 1.045 1 1.056 1 1.063v8.616c0 .007.001.018.017.033.017.016.043.03.081.03h8.9a.113.113 0 00.08-.03c.016-.015.017-.026.017-.033V1.063c0-.007-.001-.018-.017-.033a.113.113 0 00-.08-.03zm12.905 0h-8.9a.113.113 0 00-.08.03c-.016.015-.017.026-.017.033v8.616c0 .007.001.018.017.033.016.016.043.03.08.03h8.9a.113.113 0 00.08-.03C23 9.697 23 9.686 23 9.68V1.063c0-.007-.001-.018-.017-.033a.113.113 0 00-.081-.03zM9.997 14.258H1.098a.113.113 0 00-.08.03C1 14.303 1 14.314 1 14.32v8.616c0 .007.001.018.017.033.017.016.043.03.081.03h8.9a.113.113 0 00.08-.03c.016-.015.017-.026.017-.033V14.32c0-.007-.001-.018-.017-.033a.113.113 0 00-.08-.03zm12.905 0h-8.899a.113.113 0 00-.08.03c-.017.015-.018.026-.018.033v8.616c0 .007.001.018.017.033.017.016.043.03.081.03h8.9a.113.113 0 00.08-.03c.016-.015.017-.026.017-.033V14.32c0-.007-.001-.018-.017-.033a.113.113 0 00-.08-.03zM1.098 0h8.9c.606 0 1.097.476 1.097 1.063v8.616c0 .587-.492 1.063-1.098 1.063H1.098C.492 10.742 0 10.266 0 9.679V1.063C0 .476.492 0 1.098 0zm12.905 0h8.899C23.508 0 24 .476 24 1.063v8.616c0 .587-.492 1.063-1.098 1.063h-8.9c-.606 0-1.097-.476-1.097-1.063V1.063c0-.587.492-1.063 1.098-1.063zM9.997 13.258H1.098c-.606 0-1.098.476-1.098 1.063v8.616C0 23.524.492 24 1.098 24h8.9c.606 0 1.097-.476 1.097-1.063V14.32c0-.587-.492-1.063-1.098-1.063zm4.006 0h8.9c.606 0 1.097.476 1.097 1.063v8.616C24 23.524 23.51 24 22.902 24h-8.899c-.606 0-1.098-.476-1.098-1.063V14.32c0-.587.492-1.063 1.098-1.063z"
      fill="currentColor"
    />
  </svg>
);

export default IconGridList;
